import { Journey } from '@audibene/ta.utils-opportunity'
import { SchedulingMode, SearchParameters, UtmSource } from '../../constants'
import { useReferrerContext } from 'hooks/useReferrerContext'
import { useFeatureFlags } from '../useFeatureFlags'
import { useSearchParameters } from '../useSearchParameters'

/**
 * Hook to determine if consultant appointment type restrictions should apply
 * Returns true when:
 * - Feature flag RESTRICT_CONSULTANT_APPOINTMENT_TYPES_HAE_ONLY is enabled
 * - Journey is NETWORK_STANDARD
 * - utm_source is salesforce or mode search-param is explicitly set to consultant
 */
const useShouldRestrictToHAE = (journey?: Journey | string) => {
  const { [SearchParameters.SCHEDULING_MODE]: searchParamSchedulingMode } = useSearchParameters()
  const referrerContext = useReferrerContext()

  const [isConsultantRestrictionEnabled] = useFeatureFlags<boolean>(['RESTRICT_CONSULTANT_APPOINTMENT_TYPES_HAE_ONLY'])

  const isNetworkStandard = journey === Journey.NETWORK_STANDARD
  const isReferredBySalesforce = referrerContext?.source === UtmSource.SALESFORCE
  const isExplicitlyConsultantMode = searchParamSchedulingMode === SchedulingMode.CONSULTANT

  return isConsultantRestrictionEnabled && isNetworkStandard && (isReferredBySalesforce || isExplicitlyConsultantMode)
}

export { useShouldRestrictToHAE }
